import styled from "styled-components";

import { colors } from "shared/ui/tokens";

// Центрирование и фон даёт AuthLayout — фича занимается только содержимым формы.
export const Screen = styled.div`
  width: 100%;
  padding: 24px;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 420px;
  background: ${colors.surface};
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 32px 28px;
`;

export const Title = styled.h1`
  margin: 0 0 4px;
  font-size: 22px;
  font-weight: 700;
  color: ${colors.textPrimary};
`;

export const Subtitle = styled.p`
  margin: 0 0 24px;
  font-size: 14px;
  color: ${colors.textSecondary};
`;

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const MethodSwitch = styled.button`
  margin-top: 16px;
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  font-size: 14px;
  color: ${colors.primary};
  cursor: pointer;

  &:disabled {
    color: ${colors.textSecondary};
    cursor: default;
  }
`;
